var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0001 18.3307C14.6025 18.3307 18.3334 14.5998 18.3334 9.9974C18.3334 5.39502 14.6025 1.66406 10.0001 1.66406C5.39771 1.66406 1.66675 5.39502 1.66675 9.9974C1.66675 14.5998 5.39771 18.3307 10.0001 18.3307Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0916 13.2745C12.9833 13.2745 12.875 13.2495 12.775 13.1828L10.1916 11.6411C9.54995 11.2578 9.07495 10.4161 9.07495 9.67448V6.25781C9.07495 5.91615 9.35828 5.63281 9.69995 5.63281C10.0416 5.63281 10.325 5.91615 10.325 6.25781V9.67448C10.325 9.97448 10.575 10.4161 10.8333 10.5661L13.4166 12.1078C13.7166 12.2828 13.8083 12.6661 13.6333 12.9661C13.5083 13.1661 13.3 13.2745 13.0916 13.2745Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.ec6a869c2f20d35ed84943daa99fe544.svg";
export { ForwardRef as ReactComponent };